var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8718 14 14 10.8462 14 7C14 3.12821 10.8718 0 7 0C3.12821 0 0 3.12821 0 7C0 10.8462 3.12821 14 7 14ZM4.10256 6.46154L5.89744 8.25641L9.89744 4.25641L10.8205 5.17949L10.7436 5.25641L5.89744 10.0769L3.17949 7.35897L4.10256 6.46154Z",
    fill: "#66BB6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6c0ba4b32e96a77c70bb575811d427b5.svg";
export { ForwardRef as ReactComponent };